// extracted by mini-css-extract-plugin
export var centerText = "_5z-8";
export var container = "_5z-0";
export var doughnutContainer = "_5z-7";
export var legend = "_5z-a";
export var legendItemColorDisplay = "_5z-b";
export var legendItemLabel = "_5z-d";
export var legendItemValue = "_5z-c";
export var lg = "_5z-5";
export var maxWidth = "_5z-9";
export var md = "_5z-4";
export var responsive = "_5z-6";
export var sm = "_5z-3";
export var xs = "_5z-2";
export var xxs = "_5z-1";